export default __webpack_public_path__ + "static/media/text-bear.6535146b.svg";